import Link from "next/link";

export function ConsentCheckboxes({ withdrawalLabel }: { withdrawalLabel: string }) {
  return (
    <div className="space-y-3">
      <label className="flex items-start gap-2.5 text-sm text-zinc-600">
        <input
          type="checkbox"
          name="acceptTerms"
          required
          className="mt-0.5 h-4 w-4 shrink-0 accent-[#e0507a]"
        />
        <span>
          Akceptuję{" "}
          <Link
            href="/regulamin"
            target="_blank"
            className="font-bold text-[#e0507a] hover:text-[#c9436a]"
          >
            Regulamin
          </Link>{" "}
          oraz{" "}
          <Link
            href="/polityka-prywatnosci"
            target="_blank"
            className="font-bold text-[#e0507a] hover:text-[#c9436a]"
          >
            Politykę Prywatności
          </Link>
          .
        </span>
      </label>

      <label className="flex items-start gap-2.5 text-sm text-zinc-600">
        <input
          type="checkbox"
          name="acceptWithdrawal"
          required
          className="mt-0.5 h-4 w-4 shrink-0 accent-[#e0507a]"
        />
        <span>{withdrawalLabel}</span>
      </label>
    </div>
  );
}

export const DIGITAL_CONTENT_WITHDRAWAL_LABEL =
  "Wyrażam zgodę na natychmiastowe dostarczenie treści cyfrowej przed upływem ustawowego terminu do odstąpienia od umowy i przyjmuję do wiadomości, że w związku z tym utracę prawo odstąpienia od umowy.";

export const CUSTOM_TOUR_WITHDRAWAL_LABEL =
  "Wyrażam zgodę na rozpoczęcie realizacji usługi (kontakt i przygotowanie planu podróży) przed upływem ustawowego terminu do odstąpienia od umowy. Przyjmuję do wiadomości, że w przypadku odstąpienia od umowy po rozpoczęciu jej realizacji będę zobowiązany(a) do zapłaty za świadczenia spełnione do chwili odstąpienia.";
